/* eslint-disable react/no-danger */
import React, { Component, Fragment } from 'react';
import { capitalize } from 'ui-helpers';
import axios from 'axios';
import Brightcove from 'vendors/brightcove';
import BrightcovePlayer from '_shared/components/brightCovePlayer';
import Modal from 'react-modal';
import SureFitModal from './components/SureFitModal/';
import EstimateModal from './components/EstimateModal/';

const modals = {
  DICTIONARY_TERM: 'dictionary-term',
  ESTIMATE: 'estimate',
  INLINE: 'inline',
  BRIGHTCOVE: 'brightcove',
  NONE: '',
  SUREFIT: 'sureFit',
};

class Modals extends Component {
  constructor(props) {
    super(props);
    this.defaultHeight = 400;
    this.defaultWidth = 600;
    this.state = {
      content: null,
      hasMedia: false,
      hasVideo: false,
      height: this.defaultHeight,
      modalToOpen: modals.NONE,
      name: '',
      width: this.defaultWidth,
      videoId: '',
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onLoad = this.onLoad.bind(this);
  }

  componentDidMount() {
    document.addEventListener('click', (e) => {
      let obj = e.target;
      if (obj.closest('.dictionary-term')) {
        obj = !obj.matches('.dictionary-term') ? obj.closest('.dictionary-term') : obj;
      } else if (obj.closest('.video-click')) {
        obj = !obj.matches('.video-click') ? obj.closest('.video-click') : obj;
      }
      const bc = new Brightcove();
      const injectVideo = (videoName, videoOnly = true, term = '') =>
        bc
          .getVideosByProductId(videoName)
          .then((videos) =>
            videos.forEach((video) => {
              const { name, id } = video;
              if (!videoOnly) {
                this.setState({
                  name,
                  videoId: id,
                });
                this.openModal(modals.DICTIONARY_TERM, obj);
              } else {
                this.setState({
                  name,
                  videoId: id,
                });
                this.openModal(modals.BRIGHTCOVE, obj);
              }
            })
          )
          .catch(() => {
            if (term) {
              this.setState({
                videoId: '',
                name: term,
              });
              this.openModal(modals.DICTIONARY_TERM, obj);
            } else {
              this.setState({
                videoId: '',
                name: term,
              });
              this.openModal(modals.BRIGHTCOVE, obj);
            }
          });

      if (obj.matches('[data-action="close-modal"]')) {
        this.closeModal();
        return;
      }

      if (obj.matches('[data-type="inline-modal"]')) {
        e.preventDefault();
        const hash = obj.getAttribute('href');
        const content = document.querySelector(hash).innerHTML;
        this.setState({
          content,
        });
        const { webFontsEvent } = window;
        window.dispatchEvent(webFontsEvent);
        this.openModal(modals.INLINE);
      } else if (obj.matches('[data-type="iframe"]')) {
        e.preventDefault();
        const href = obj.getAttribute('href');
        const content = `<iframe src="${href}" width="100%" height="100%"></iframe>`;
        this.setState({
          content,
        });
        const { webFontsEvent } = window;
        window.dispatchEvent(webFontsEvent);
        this.openModal(modals.INLINE);
      } else if (obj.closest('.dictionary-term') || obj.closest('.video-click')) {
        // TODO: the .video-click added via admin (site product level) should be replaced with:
        // <a href={link to the video in liveclicker} class="dictionary-term" data-width="600" data-height="400" data-videoname={videoCodeInLiveClicker}>{Term}</a>
        e.preventDefault();
        e.stopImmediatePropagation();
        if (obj.matches('[href^="/DictionaryManagement"]')) {
          axios
            .get(obj.href, {
              headers: {
                'Content-Type': 'application/json',
              },
            })
            .then(({ data }) => {
              const { term, definition, video } = data;
              let { image } = data;
              // This is the hash code of the "not available" image
              if (image && image.indexOf('c4a3dd83-7bba-e311-a64d-84df7b46b4ac') >= 0) {
                image = null;
              }
              const name = capitalize(term);
              this.setState({
                content: definition,
                hasMedia: !!video || !!image,
                hasVideo: !!video,
                image,
                name,
              });
              this.openModal(modals.DICTIONARY_TERM, obj);
              if (video) {
                injectVideo(video, false);
              }
            });
        } else if (obj.matches('[data-videoname]')) {
          const { videoname } = obj.dataset;
          injectVideo(videoname, true);
        }
      }
    });
  }

  onLoad() {
    const { onLoad } = this.state;
    if (typeof window[onLoad] === 'function') {
      window[onLoad]();
    }
  }

  openModal(modalName, obj) {
    const clickedObject = obj || event.target;
    const height = clickedObject.dataset.height || this.state.height;
    const onLoad = clickedObject.dataset.onload || this.state.onload;
    const title = clickedObject.dataset.title || this.state.title;
    const width = clickedObject.dataset.width || this.state.width;
    this.setState({
      height: parseInt(height, 10),
      modalToOpen: modalName,
      onLoad,
      title,
      width: parseInt(width, 10),
    });
  }

  closeModal() {
    history.pushState('', document.title, window.location.pathname + window.location.search);
    this.setState({
      height: this.defaultHeight,
      modalToOpen: modals.NONE,
      title: '',
      width: this.defaultWidth,
      videoId: '',
    });
  }

  render() {
    const { content, hasMedia, hasVideo, height, image, modalToOpen, name, width, title } = this.state;
    return (
      <Fragment>
        {modalToOpen && (
          <Modal
            isOpen
            contentLabel="Modal"
            onRequestClose={this.closeModal}
            closeTimeoutMS={200}
            className="gcc-modal"
            onAfterOpen={this.onLoad}
            overlayClassName="gcc-modal-overlay"
            style={{
              content: {
                height,
                width,
              },
            }}
          >
            <header className="bb pa2 b--mid-gray flex items-start justify-between flex-shrink-0">
              <h2 className="fw5 f5 ml2 h2 flex items-center">{name}</h2>
              <button
                type="button"
                className="f3 outline-0 pointer bn pa0 ma0 br-100 bn w2 h2 flex-shrink-0 flex items-center justify-center hover-bg-light-gray hover-blue"
                onClick={this.closeModal}
              >
                <span className="material-icons">clear</span>
              </button>
            </header>
            {modalToOpen === modals.SUREFIT && <SureFitModal />}
            {modalToOpen === modals.ESTIMATE && <EstimateModal />}
            {modalToOpen === modals.INLINE && (
              <div className="pa3 flex-auto overflow-y-auto">
                <div className="h-100" dangerouslySetInnerHTML={{ __html: content }} />
              </div>
            )}
            {modalToOpen === modals.BRIGHTCOVE && (
              <div className="flex-auto h-100 relative">
                <BrightcovePlayer
                  videoId={this.state.videoId}
                  accountId={window.globalConfig.brightcove.accountId}
                  playerId={window.globalConfig.brightcove.playerId}
                />
              </div>
            )}
            {modalToOpen === modals.DICTIONARY_TERM && (
              <div className="flex-auto h-100 relative">
                <div className={`flex pa3 flex-auto ${hasVideo ? 'flex-wrap' : ''} overflow-y-auto h-100`}>
                  {hasMedia && (
                    <div className={`${hasVideo ? 'flex-auto w-100 w-60-ns' : 'mw4'}`}>
                      {hasVideo && (
                        <div className="aspect-ratio aspect-ratio--16x9 mb3 mb0-ns">
                          <div className="aspect-ratio--object cover">
                            <BrightcovePlayer
                              videoId={this.state.videoId}
                              accountId={window.globalConfig.brightcove.accountId}
                              playerId={window.globalConfig.brightcove.playerId}
                            />
                          </div>
                        </div>
                      )}
                      {!hasVideo && <img src={image} alt={`${name}`} />}
                    </div>
                  )}
                  <div className={`w-100 lh-copy ${hasMedia ? 'pl3-ns' : ''} ${hasVideo ? 'w-40-ns' : ''} `}>
                    <h2 className="fw7 f5 f4-ns mb2 lh-title ttc">{title}</h2>
                    <div dangerouslySetInnerHTML={{ __html: content }} />
                  </div>
                </div>
              </div>
            )}
          </Modal>
        )}
      </Fragment>
    );
  }
}

export default Modals;
